<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <v-snackbar v-model="snackbar" color="#FEBD08" right :timeout="timeout">
      <v-layout wrap>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="snackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center px-2 px-lg-7 pb-12>
      <v-flex xs12 sm8 md8 py-6 pl-lg-12>
        <v-layout wrap>
          <v-flex xs6 style="font-family: robotoregular; color: grey">
            <span>Home</span> > <span style="color: black">My Account</span>
          </v-flex>
          <!-- <v-flex xs6 lg6 text-right>
            <v-btn small outlined tile @click="add()"> EDIT </v-btn>
          </v-flex> -->
        </v-layout>
      </v-flex>
      <v-flex sm8 md6 lg5>
        <v-layout wrap justify-center>
          <v-flex xs12 text-center class="head" pb-4 pb-md-7 pt-5>
            My Account
          </v-flex>
          <v-flex xs12 text-center>
            <v-avatar v-if="profile.photo && !imagePreview" size="130">
              <v-img :src="mediaURL + profile.photo" />
            </v-avatar>
            <v-avatar v-if="imagePreview" size="130">
              <v-img
                v-if="imagePreview"
                :src="imagePreview"
                width="150px"
                height="150px"
                class="align-center"
                contain
              />
            </v-avatar>
            <v-avatar v-if="!profile.photo && !imagePreview" size="130">
              <v-img src="../../assets/images/nouser.png" />
            </v-avatar>
          </v-flex>
          <v-flex
            xs12
            text-center
            pt-1
            pb-md-10
            pb-5
            style="
              color: grey;
              font: 14px robotoregular;
              text-decoration-line: underline;
            "
          >
            <v-btn
              text
              tile
              depressed
              :ripple="false"
              @click="$refs.showImage.click()"
              style="
                color: grey;
                font: 14px robotoregular;
                text-transform: capitalize;
              "
              >Change Picture</v-btn
            >
            <input
              v-show="false"
              accept="image/*"
              id="file"
              ref="showImage"
              multiple="multiple"
              type="file"
              @change="showImage"
            />
          </v-flex>
          <v-flex sm6 pr-sm-1>
            <v-text-field
              class="textfd"
              v-model="profile.firstname"
              dense
              outlined
              label="First Name"
            >
            </v-text-field>
          </v-flex>
          <v-flex sm6 pl-sm-1>
            <v-text-field
              class="textfd"
              v-model="profile.lastname"
              dense
              outlined
              tile
              label="Last Name"
            >
            </v-text-field>
          </v-flex>
          <!-- <v-flex xs12>
          <v-text-field
            class="textfd"
            outlined
            tile
            dense
            label="Company ( Optional)"
          >
          </v-text-field>
        </v-flex> -->
          <v-flex xs12>
            <v-text-field
              class="textfd"
              outlined
              tile
              dense
              label="Email"
              v-model="profile.email"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              class="textfd"
              v-model="profile.streetAddress"
              dense
              outlined
              tile
              label="Address"
            >
            </v-text-field>
          </v-flex>
          <!-- <v-flex xs12>
          <v-text-field
            class="textfd"
            outlined
            tile
            dense
            label="Apartment, Suite, etc"
          >
          </v-text-field>
        </v-flex> -->
          <v-flex xs12>
            <v-text-field
              class="textfd"
              v-model="profile.city"
              dense
              outlined
              tile
              label="City"
            >
            </v-text-field>
          </v-flex>
          <v-flex sm4 pr-sm-1>
            <v-text-field
              class="textfd"
              v-model="profile.country"
              dense
              outlined
              readonly
              tile
              label="Country"
            >
            </v-text-field>
          </v-flex>
          <v-flex sm4 px-sm-1>
            <v-select
              :items="state"
              class="textfd"
              v-model="profile.state"
              dense
              outlined
              tile
              item-text="name"
              item-value="value"
              label="State"
            ></v-select>
          </v-flex>
          <v-flex sm4 pl-sm-1>
            <v-text-field
              class="textfd"
              v-model="profile.pincode"
              dense
              outlined
              tile
              label="Pin"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              style="height: 43px"
              color="grey"
              class="textfd"
              outlined
              label="Phone"
              dense
              type="number"
              v-model="profile.phone"
            >
            </v-text-field>
          </v-flex>
        </v-layout>
        <v-layout justify-center wrap py-5>
          <v-flex xs6 sm6 md3>
            <v-btn outlined block tile @click="validateInput()">Submit</v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["id"],
  data() {
    return {
      profile: {
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        city: "",
        state: "",
        country: "",
        pincode: "",
        streetAddress: "",
      },
      showPreview: false,
      file: null,
      file1: null,
      imagePreview: "",
      dialog: false,
      appLoading: false,
      snackbar: false,
      msg: "",
      timeout: 5000,
      flag: true,
      state: [],
    };
  },
  mounted() {
    this.getData();
    this.getState();
  },
  methods: {
    validateInput() {
      if (!this.profile.firstname) {
        this.msg = "Please Provide First name";
        this.snackbar = true;
        return;
      } else if (!this.profile.lastname) {
        this.msg = "Please Provide Last name";
        this.snackbar = true;
        return;
      } else if (!this.profile.phone) {
        this.msg = "Please Provide Phone";
        this.snackbar = true;
        return;
      } else if (this.profile.phone.length != 10) {
        this.msg = "Please enter valid number";
        this.snackbar = true;
        return;
      } else if (!this.profile.email) {
        this.msg = "Please Provide Email";
        this.snackbar = true;
        return;
      } else if (!this.profile.streetAddress) {
        this.msg = "Please Provide Address";
        this.snackbar = true;
        return;
      } else {
        this.add();
      }
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/profile",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      }).then((response) => {
        this.appLoading = false;
        if (response.data.status) {
          var temp = {};
          temp = response.data.data;
          this.profile.firstname = temp.firstname;
          this.profile.lastname = temp.lastname;
          this.profile.email = temp.email;
          this.profile.country = temp.address.country;
          this.profile.state = temp.address.state;
          this.profile.city = temp.address.city;
          this.profile.pincode = temp.address.pincode;
          this.profile.streetAddress = temp.address.streetAddress;
          this.profile.phone = temp.phone;
          this.profile.photo = temp.photo;
        } else {
          console.log("no data ");
        }
      });
    },
    getState() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/states/list",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      }).then((response) => {
        this.appLoading = false;
        if (response.data.status) {
          this.state = response.data.data;
        } else {
          console.log("no data ");
        }
      });
    },
    add() {
      this.appLoading = true;
      axios({
        url: "/customer/profile/update",
        method: "POST",
        data: this.profile,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Updated Sucessfully";
            this.snackbar = true;
            this.uploadImage();
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.snackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    showImage(e) {
      this.file1 = e.target.files[0];
      console.log(e);
      var reader = new FileReader();
      reader.onload = (e) => {
        this.$refs.showImage.value = null;
        this.imagePreview = e.target.result;
      };
      if (this.file1.size > 3145728) {
        this.msg = "File Should be less than 3MB";
        this.snackbar = true;
        return;
      }
      this.showPreview = true;
      if (this.file1) {
        if (/\.(jpe?g|png|gif)$/i.test(this.file1.name)) {
          reader.readAsDataURL(this.file1);
        }
      }
    },
    uploadImage() {
      let formData = new FormData();
      formData.append("photo", this.file1);
      axios({
        method: "POST",
        url: "/customer/photo/upload",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.msg = "Uploaded Successully";
            this.snackbar = true;
            this.showPreview = null;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.snackbar = true;
          }
        })
        .catch((err) => {
          this.showsnackbar = true;
          this.appLoading = false;
          console.log(err);
        });
    },
  },
};
</script>